<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12"><path stroke="#fff" stroke-width="2" d="M1.74 6.283 5 9l5.435-6.522"/></svg></template>
<script>
export default {
  name: "CheckedIcon"
}
</script>

<style lang="scss">

</style>